export default class Top {
  constructor(gsap, ScrollTrigger, Swiper) {
    const mainClass = document.getElementsByTagName("main")[0].classList.value;
    if (mainClass === "top") {
      // Gsap  mediaクエリ
      let mm = gsap.matchMedia();

      const mv = document?.getElementById("mv");

      //クリップパス CSS => aに値を追加することで大きさを調整（必ず中央寄せ）
      const cp = (a) => {
        return "circle(" + a + " at center)";
      };

      const mvSlider = new Swiper(".mv__slider", {
        effect: "fade",
        // effect: "creative",
        slidesPerView: 1,
        autoplay: {
          delay: 5000,
        },
        allowTouchMove: false,
        // pauseOnMouseEnter: true, //ホバー時停止
        loop: true,

        on: {
          init: function () {
            // ScrollTrigger.refresh();
          },
          slideChange: function () {
            //
            ScrollTrigger.refresh(); //これを入れないと正しい位置にならない
          },
        },
      });

      ScrollTrigger.refresh();

      // /* --------------------------------
      // Products 横スクロール
      // -------------------------------- */
      const secProducts = document.querySelector(".p-top-sec-products");
      const productsContainer = document.querySelector(".js-products__container");
      const productsItem = document.querySelectorAll(".js-products__item");

      let totalProductItemWidth = 0;

      ///製品のアイテムの数分のWidthを取得
      productsItem.forEach((item) => {
        const productItemWidth = item.clientWidth;
        totalProductItemWidth += productItemWidth;
      });
      const productItemLength = productsItem.length;

      const totalProductWidth = totalProductItemWidth + (productItemLength - 1) * 30; // 30 => ProductItemのgap分

      mm.add("(min-width: 768px)", () => {
        gsap.to(productsItem, {
          x: () => -(totalProductWidth - productsContainer?.clientWidth),

          scrollTrigger: {
            trigger: secProducts,
            pin: true,
            scrub: 0.5,
            end: () => "+=" + totalProductWidth,
            anticipatePin: 1,
            invalidateOnRefresh: true,
            // markers: true,
          },
        });
      });

      // /* --------------------------------
      // About 背景円拡大
      // -------------------------------- */
      const secAbout = document.querySelector(".p-top-sec-about");
      const aboutCircle = document.querySelector(".js-about__circle");

      mm.add("(min-width: 768px)", () => {
        let tl_circle = gsap.timeline({
          scrollTrigger: {
            trigger: secAbout,
            start: "top bottom",
            end: "bottom top",
            scrub: 1,
            invalidateOnRefresh: true,
            // markers: true,
          },
        });
        // tl_circle = gsap.timeline();
        tl_circle.to(aboutCircle, {
          clipPath: cp("50%"),
        });
        tl_circle.to(aboutCircle, {
          clipPath: cp("8%"),
        });
        // tl_circle.scrollTrigger.refresh();
        ScrollTrigger.refresh();
      });

      mm.add("(max-width: 767px)", () => {
        // tl_circle_sp = gsap.timeline();
        let tl_circle_sp = gsap.timeline({
          scrollTrigger: {
            trigger: secAbout,
            start: "top 80%",
            end: "bottom -20%",
            scrub: 1,
            invalidateOnRefresh: true,
          },
        });
        tl_circle_sp.to(aboutCircle, {
          clipPath: cp("50%"),
          willChange: "clip-path",
        });
        // tl_circle_sp.to(aboutCircle, {
        //   clipPath: cp("40%"),
        // });
        tl_circle_sp.to(aboutCircle, {
          clipPath: cp("10%"),
          willChange: "unset",
        });
        ScrollTrigger.refresh();

        // tl_circle_sp.scrollTrigger.refresh();
      });
      // });

      // /* --------------------------------
      // Fixed お問い合わせボタン
      // -------------------------------- */

      const fixedContact = document.getElementById("js-fixed__contact");
      const mvContact = document.getElementById("js-mv__contact");

      //フッター付近に来たら削除
      gsap.fromTo(
        fixedContact,
        {
          autoAlpha: 1,
        },
        {
          autoAlpha: 0,
          duration: 0.2,
          scrollTrigger: {
            trigger: ".l-footer",
            start: "top bottom",
            toggleActions: "play resume resume reset",
          },
        }
      );

      //SP時のみ、フローティングボタンはMVを過ぎたら下から出現
      mm.add("(max-width: 767px)", () => {
        gsap.fromTo(
          fixedContact,
          {
            y: "100%",
          },
          {
            duration: 0.4,
            y: "0",
            scrollTrigger: {
              trigger: mv,
              start: "bottom+=100 bottom",
              toggleActions: "play resume resume reset",
            },
          }
        );
        ScrollTrigger.refresh();
      });

      //SP時のみ、MVにお問い合わせボタン右下につけてフローティングボタンとは別にする
      mm.add("(max-width: 767px)", () => {
        gsap.fromTo(
          mvContact,
          {
            // autoAlpha: 1,
          },
          {
            autoAlpha: 0,
            duration: 0.2,
            scrollTrigger: {
              trigger: mv,
              start: "bottom+=100 bottom", //アドレスバー分足したい
              toggleActions: "play resume resume reset",
              // toggleClass: { targets: fixedContact, className: "is-bottom" },
              // markers: true,
            },
          }
        );
        ScrollTrigger.refresh();
      });
      //PC時のみ、
      mm.add("(min-width: 768px)", () => {
        gsap.fromTo(
          ".l-header",
          {
            // autoAlpha: 1,
            backgroundColor: "transparent",
          },
          {
            backgroundColor: "rgba(237, 237, 237, 0.9)",
            duration: 0.2,
            ease: "none",
            scrollTrigger: {
              trigger: mv,
              start: "bottom bottom",
              toggleActions: "play resume resume reset",
            },
          }
        );
        ScrollTrigger.refresh();
      });
    }
  }
}
